import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiClient, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const emptyForm = { title: "", excerpt: "", content: "", published: true };

export default function AdminBlogForm() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isEdit) {
      apiClient.get("/admin/blog").then((res) => {
        const post = res.data.find((p) => p.id === id);
        if (post) setForm(post);
      });
    }
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      if (isEdit) await apiClient.put(`/admin/blog/${id}`, form);
      else await apiClient.post("/admin/blog", form);
      toast.success(`Article ${isEdit ? "updated" : "created"}`);
      navigate("/admin/blog");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div className="max-w-2xl" data-testid="admin-blog-form-page">
      <h1 className="text-2xl font-display font-semibold text-slate-900 mb-6">{isEdit ? "Edit Article" : "New Article"}</h1>
      <form onSubmit={handleSubmit} className="bg-white border border-slate-200 rounded-md shadow-sm p-6 space-y-4">
        <div><Label>Title</Label><Input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="blog-form-title" /></div>
        <div><Label>Excerpt</Label><Textarea required rows={2} value={form.excerpt} onChange={(e) => setForm({ ...form, excerpt: e.target.value })} data-testid="blog-form-excerpt" /></div>
        <div><Label>Content</Label><Textarea required rows={8} value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} data-testid="blog-form-content" /></div>
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.published} onChange={(e) => setForm({ ...form, published: e.target.checked })} data-testid="blog-form-published" /> Published</label>
        {error && <p className="text-sm text-red-500">{error}</p>}
        <div className="flex gap-3">
          <Button type="submit" className="rounded-md" data-testid="blog-form-submit">Save Article</Button>
          <Button type="button" variant="outline" className="rounded-md" onClick={() => navigate("/admin/blog")}>Cancel</Button>
        </div>
      </form>
    </div>
  );
}
